import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * PD-17428 — a person or role who can edit a scheduled report alongside its
 * owner. Only the owner deletes it or changes who it is read as.
 */
@Index('idx_report_schedule_share_schedule', ['fkReportScheduleId'])
@Entity('report_schedule_share')
export class ReportScheduleShareEntity extends BaseEntity {
	@Column('int', { name: 'fk_report_schedule__id', unsigned: true })
	public fkReportScheduleId!: number;

	@Column('int', { name: 'fk_user__id', unsigned: true, nullable: true })
	public fkUserId!: number | null;

	@Column('int', { name: 'fk__rbac_role__id', unsigned: true, nullable: true })
	public fkRbacRoleId!: number | null;
}
